namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailSchvalovaciRoleEpk extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GSchvalovaciRoleEpkReadDto;
        private newRecord: boolean;
        private detailObj: DetailSchvalovaciRoleEpkObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailSchvalovaciRoleEpkObj());
            this.detailObj.createBase({
                contentName: "detailSchvalovaciRoleEpk",
                contentCaption: "jres:32131048",  //RC 33000887 : Skupina funkcí
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.getFunkceSchvalovaciRoleEpkTab());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getFunkceSchvalovaciRoleEpkGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailSchvalovaciRoleEpk", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailSchvalovaciRoleEpkObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GSchvalovaciRoleEpkReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return `${this.data.ixs_sro}`;
        }

        saveData(data: Gordic.AdmIsl.Interface.GSchvalovaciRoleEpkSaveDto, close: boolean) {
            this.cnt.isl.SchvalovaciRoleEpk.upsert({ data: data }).get().done((output: any) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderWflssro");
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).catch((err) => {
                this.pendingAction("actSave", false)
                throw err;
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailSchvalovaciRoleEpk", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.SchvalovaciRoleEpk.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.data.nazev}`;
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                {
                    caption: "jres:33000138",
                    favorite: true,
                    icon: "fa-link",
                    visible: this.options.newRecord == false,
                    children: [
                        { action: this.cnt.actions.actSeznamFunkceSchvalovaciRoleEpk }
                    ]
                },
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actSeznamFunkceSchvalovaciRoleEpk: {
                    icon: "fa-link",
                    caption: "jres:33000896", //RC 33000896 : Přiřazená funkční místa
                    visible: this.options.newRecord == false,
                    run: (ev, ctx) => {
                        this.openSeznamFunkceSchvalovaciRoleEpk();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ekosico(), {
                model: "model.ico=value.ico",
                flag: this.createFlagNemenne()
            })
            this.MakeField("ixs_sro", {
                flag: this.createFlagNemenne()
            });
            this.MakeField("nazev")
            this.MakeField("zkratka")
            this.MakeSelectField("ktg_sch_role", Gordic.Prefabs.Select.wflcksr(), {
                model: "model.ktg_sch_role=value.ktg_sch_role"
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private openSeznamFunkceSchvalovaciRoleEpk() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamFunkceSchvalovaciRoleEpk", { ixs_sro: this.data.ixs_sro })
        }

        getFunkceSchvalovaciRoleEpkTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-funkce-schvalovaci-role",
                    title: "jres:33000896", //RC 33000863 : Účtárny fun. místa
                    opened: true,
                    locked: true,
                    group: { id: "_tab-funkce-schvalovaci-role" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamFunkceSchvalovaciRoleEpk",
                    serverParams: {
                        ID: "SeznamFunkceSchvalovaciRoleEpk",
                        ixs_sro: this.data.ixs_sro,
                        tabOpen: true
                    }
                }
            }
        }

        getFunkceSchvalovaciRoleEpkGroup(): IGTabGroupOptions {
            return { id: "_tab-funkce-schvalovaci-role", caption: "jres:33000896" }
        }
    }
}